import {ChangeDetectorRef, Component, TemplateRef, ViewChild} from '@angular/core';
import {
  CtBinaryOperator,
  CtDatatableActionConfiguration,
  CtDatatableActionCustomConfiguration,
  CtDatatableConfiguration,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtModelOperator,
  CtModelRouteData,
  CtModelService,
  CtModelType
} from "@ctsolution/ct-framework";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi";
import {ActivatedRoute, Router} from "@angular/router";
import {UserRouteData} from "../../../_core/route-data/user.route-data";
import {UserInfoFormTemplateRouteData} from "../../../_core/route-data/user-info-form-template.route-data";
import {FormTemplateRouteData} from "../../../_core/route-data/form-template.route-data";
import {DEFAULT_DATATABLE_CONFIGURATION} from "../../../_core/constants";
import {CtFieldCustomColumn} from "@ctsolution/ct-framework/lib/ct-datatable/_core/ct-field-custom.column";
import {Role} from "../../../_core/enum/role";
import {UserFeeManagerConfiguration} from "../user-fee-manager/user-fee-manager.configuration";
import {CtManagerService} from "../../../_core/lib/ct-manager.service";
import { ChangePasswordParameter, CtAuthenticationService, CtProfileService } from '@ctsolution/ct-authentication';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { UserChangePasswordDialogComponent, UserChangePasswordResult } from './user-change-password-dialog/user-change-password-dialog.component';
import { JwtService } from '../../../_core/lib/jwt.service';

@Component({
  selector: 'app-user-edit',
  template: `
    <ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>

    <ng-container *ngIf="enableFeeManager">
      <div class="ct-manager-master-detail-container">
        <app-user-fee-manager [configuration]="userFeeManagerConfiguration"></app-user-fee-manager>
      </div>
    </ng-container>

    <ng-container *ngIf="enableMasterDetail && this.viewModel.MONITORING">

      <app-user-info-work-data></app-user-info-work-data>

    </ng-container>

    <!-- Moduli (CTFormTemplate) collegati allo user - solo se la feature "Modules" è abilitata in SiteConfiguration -->
    <ng-container *ngIf="enableMasterDetail && viewModel.MODULES && modulesDatatable">
      <div class="modules-datatable-cntr">
        <div class="title-model-cntr">
          <h3>Moduli:</h3>
          <h4>Moduli collegati a questo utente.</h4>
        </div>
        <mat-card>
          <mat-card-content>
            <div class="modules-toolbar">
              <button mat-raised-button color="primary" (click)="addModule()">
                <mat-icon>add</mat-icon> Aggiungi
              </button>
            </div>
            <ct-datatable [configuration]="modulesDatatable" (reload)="onModulesReload()"></ct-datatable>
          </mat-card-content>
        </mat-card>
      </div>
    </ng-container>

    <!-- Cella "Visionato": pallino verde (visionato) / rosso (non visionato) -->
    <ng-template #modulesViewedCell let-row="row">
      <span
        class="status-dot"
        [class.viewed]="row?.viewed"
        [class.not-viewed]="!row?.viewed"
        [title]="row?.viewed ? 'Visionato' : 'Non visionato'"></span>
    </ng-template>

    <!-- Sezione cambio password - visibile solo se sono nel dettaglio del mio utente -->
    <ng-container *ngIf="enableMasterDetail && isUserHimself">
        <app-change-password-card
    *ngIf="!isLoading"
    title="Account"
    description="Modifica la tua password"
    buttonLabel="Modifica Password">
  </app-change-password-card>
    </ng-container>

    <!-- Popup: lista di TUTTI i documenti (FormTemplate/List, niente Lookup), non filtrati per utente -->
    <ng-template #addModuleDialog>
      <h2 mat-dialog-title>Aggiungi documento</h2>
      <mat-dialog-content>
        <ct-model *ngIf="selectDocumentConfiguration" [configuration]="selectDocumentConfiguration"></ct-model>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Chiudi</button>
      </mat-dialog-actions>
    </ng-template>
  `,
  styles: [`
    /* Card container per la sezione cambio password */
    :host ::ng-deep .change-password-card {
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      padding: 24px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      transition: box-shadow 0.3s ease;
      margin: 20px 15px !important;
    }

    .change-password-card:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    /* Header della card con icona e testi */
    .card-header {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 20px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;
    }

    .header-icon {
      color: #006595; /* Colore primario dal tuo progetto */
      font-size: 32px;
      width: 32px;
      height: 32px;
    }

    .header-content {
      flex: 1;
    }

    .card-title {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 1.4;
    }

    .card-description {
      margin: 4px 0 0 0;
      font-size: 14px;
      color: #666666;
      line-height: 1.5;
    }

    /* Sezione azioni con il pulsante */
    .card-actions {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .card-actions button {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 24px;
      height: 40px;
      font-size: 14px;
      font-weight: 500;
    }

    .card-actions button mat-icon {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }

    /* Titolo sezione moduli: stesso stile di "Dati Contrattuali" (scoped nell'altro componente) */
    .title-model-cntr {
      display: flex;
      flex-direction: column;
      padding-left: 20px;
    }
    .title-model-cntr h4 {
      margin-top: 0;
    }

    /* Toolbar tabella moduli (bottone Aggiungi) */
    .modules-toolbar {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 8px;
    }

    /* Pallino stato "Visionato" */
    .status-dot {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #bdbdbd;
    }
    .status-dot.viewed { background: #4caf50; }
    .status-dot.not-viewed { background: #f44336; }

    /* Nessuna freccia di ordinamento in testata */
    ::ng-deep .modules-datatable-cntr .sort-btn {
      display: none !important;
    }

    /* Tabella moduli: celle a sinistra e centrate in verticale */
    ::ng-deep .modules-datatable-cntr .datatable-body-cell {
      display: flex !important;
      align-items: center !important;
    }
    ::ng-deep .modules-datatable-cntr .datatable-body-cell .datatable-body-cell-label,
    ::ng-deep .modules-datatable-cntr .datatable-header-cell .datatable-header-cell-label {
      display: flex;
      align-items: center;
      justify-content: flex-start !important;
      text-align: left !important;
    }
  `]
})
export class UserEditComponent {

  configuration: CtModelConfiguration<UserEditComponent> | null = null;
  userFeeManagerConfiguration: UserFeeManagerConfiguration = UserFeeManagerConfiguration
    .create();

  /** Tabella dei moduli collegati allo user (dati da UserInfo_FormTemplate/OwnedOnlyList). */
  modulesDatatable: CtDatatableConfiguration | null = null;

  /** Oid dello user in dettaglio (per l'associazione dei nuovi moduli). */
  private modulesUserOid: number | null = null;

  /** Template della cella "Visionato": pallino verde/rosso. */
  @ViewChild('modulesViewedCell') modulesViewedCellTpl: TemplateRef<any> | null = null;

  /** Lista (nel popup) di TUTTI i documenti FormTemplate, non filtrati per utente. */
  selectDocumentConfiguration: CtModelConfiguration<any> | null = null;

  @ViewChild('addModuleDialog') addModuleDialogTpl: TemplateRef<any> | null = null;

  private addModuleDialogRef: any = null;

  isUserHimself: boolean = false;

  viewModel = {
    CRM: false,
    MONITORING : false,
    MODULES: false
  }

  get enableMasterDetail(): boolean {
    return !!this.configuration?.RouteData?.id;
  }

  get userHasAgentRole() {
    return this.configuration?.form?.value?.Role?.toLowerCase() === Role.AGENT.toLowerCase();
  }

  get enableFeeManager() {
    return this.userHasAgentRole && this.enableMasterDetail && this.viewModel.CRM;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private managerService: CtManagerService,
    private cdr : ChangeDetectorRef,
    private jwtService : JwtService,
    private modelService : CtModelService <any>,
    private dialog: MatLegacyDialog
  ) {
  }

  ngAfterViewInit() {

    this.setup();

    this.route
    .data
    .subscribe(data => {
      data['title'] = 'CT_PAGE.BREADCRUMBS.DetailUser';
      this.cdr.detectChanges();
    })

  }

  async setup() {

    const routeData: CtModelRouteData = UserRouteData()
      .setModelType(CtModelType.FORM);

    const pId: string | null = this.route.snapshot.paramMap.get("id");

    if (pId) {

      routeData
        .setId(+pId);

      this.userFeeManagerConfiguration
        .setUserOid(routeData.id)

      this.isUserHimself = await this.checkUser(pId);

    }

    this.viewModel.CRM = await this.managerService.hasEnabled.CRM() ?? false;
    this.viewModel.MONITORING = await this.managerService.hasEnabled.monitoring() ?? false;
    this.viewModel.MODULES = await this.managerService.hasEnabled.modules() ?? false;

    // Tabella dei moduli: la carico solo se la feature "Modules" è abilitata in SiteConfiguration.
    if (pId && this.viewModel.MODULES) {
      this.loadUserModules(+pId);
    }
    const userHasMonitoringManagementEnabled = await this.managerService.hasEnabled.monitoring() ?? false;

    const fieldsCustomTemplates: CtFieldCustomColumn[] = [
      {prop: "DailyWorkingHours", visible: userHasMonitoringManagementEnabled},
      {prop: "WeeklyWorkingHours", visible: userHasMonitoringManagementEnabled},
      {prop: "WorkJob", visible: userHasMonitoringManagementEnabled},
    ];

    this.configuration = CtModelConfiguration
      .create<UserEditComponent>()
      .setRouteData(routeData)
      .setFieldsCustomTemplates(fieldsCustomTemplates)

  }

  /**
   * Carica i moduli collegati allo user in dettaglio: POST UserInfo_FormTemplate/List
   * filtrata per UserInfo.Oid = oid dell'utente (NON OwnedOnlyList, che è dell'utente loggato).
   * Colonne: Titolo, Visionato (pallino), Data visione; azione di riga: elimina.
   */
  private loadUserModules(userOid: number): void {

    this.modulesUserOid = userOid;

    // Stessa chiamata del ct-model "di prima": getList (POST /UserInfo_FormTemplate/List)
    // con il filtro costruito dalle classi del framework (serializzazione corretta del filtro).
    const configuration = CtModelConfiguration
      .create()
      .setRouteData(UserInfoFormTemplateRouteData());

    const operators = CtModelDatatableOperators
      .create()
      .setFilters([
        CTModelDatatableFilter
          .create()
          .setField('UserInfo.Oid')
          .setValue(userOid)
          .setOperatorType(CtBinaryOperator.Equal)
      ]);

    this.modelService
      .getList(configuration, operators)
      .subscribe({
        next: (response: CtWebapiGenericResponse<any>) => {

          const list = (response?.Result?.DataSource ?? []) as any[];

          const rows = list.map(row => {
            const readDate = row?.ReadCompletedDate ?? null;
            return {
              uftOid: row?.Oid,
              templateOid: row?.FormTemplate?.Oid ?? row?.Oid,
              name: row?.FormTemplate?.Name
                ?? row?.FormTemplate?.Title
                ?? row?.FormTemplate?.Description
                ?? row?.FormTemplate?.Code
                ?? `Modulo #${row?.FormTemplate?.Oid ?? row?.Oid}`,
              viewed: !!readDate,
              readDate: readDate ? new Date(readDate).toLocaleDateString('it-IT') : '-'
            };
          });

          this.modulesDatatable = CtDatatableConfiguration
            .create()
            .setScrollbarH(true)
            .setFiltersEnabled(false)
            .setExternalPaging(false)
            .setExternalSorting(false)
            .setLoadingIndicator(false)
            .setCount(rows.length)
            .setColumns([
              { prop: 'name', name: 'Titolo', sortable: false },
              { prop: 'viewed', name: 'Visionato', width: 120, sortable: false, cellTemplate: this.modulesViewedCellTpl },
              { prop: 'readDate', name: 'Data visione', width: 180, sortable: false }
            ] as any)
            .setRows(rows)
            // Azione di riga: elimina l'associazione.
            .setCustomDatatableActionConfiguration(
              CtDatatableActionCustomConfiguration
                .create()
                .setActionButtonConfig(
                  CtDatatableActionConfiguration
                    .create()
                    .setIcon('delete')
                    .setColor('warn'))
                .setCallback((row: any) => this.deleteModule(row)));

        },
        error: (err: any) => {
          console.error('Errore durante il caricamento dei moduli:', err);
          this.modulesDatatable = null;
        }
      });

  }

  /** Apre il popup di aggiunta moduli per lo user corrente. */
  addModule(): void {
    if (this.modulesUserOid) {
      this.openAddModuleDialog(this.modulesUserOid);
    }
  }

  /** Elimina l'associazione UserInfo_FormTemplate (con conferma) e ricarica. */
  private async deleteModule(row: any): Promise<void> {

    if (!row?.uftOid) return;

    const configuration = CtModelConfiguration
      .create()
      .setRouteData(UserInfoFormTemplateRouteData());

    const deleteObservable = await this.modelService.delete(configuration, { Oid: row.uftOid });

    deleteObservable?.subscribe({
      next: () => window.location.reload(),
      error: (err: any) => console.error('Errore durante l\'eliminazione del modulo:', err)
    });

  }

  /** Righe statiche: spegne l'indicatore di caricamento del datatable. */
  onModulesReload(): void {
    this.modulesDatatable?.setLoadingIndicator(false);
  }

  /**
   * Apre il popup con TUTTI i documenti (FormTemplate/List, senza Lookup), non filtrati per utente.
   * Selezionando una riga il documento viene collegato allo user (Create su UserInfo_FormTemplate).
   */
  private openAddModuleDialog(userOid: number): void {

    if (!this.addModuleDialogTpl) return;

    // Lista dei FormTemplate. Filtri disattivati per evitare qualsiasi lookup.
    // Azione di riga: solo un "+" (custom) al posto della matita → collega il documento allo user.
    const datatableConfiguration = DEFAULT_DATATABLE_CONFIGURATION()
      .setFiltersEnabled(false)
      .setCustomDatatableActionConfiguration(
        CtDatatableActionCustomConfiguration
          .create()
          .setActionButtonConfig(
            CtDatatableActionConfiguration
              .create()
              .setIcon('add')
              .setColor('primary'))
          .setCallback((row: any) => this.associateModule(userOid, row)));

    this.selectDocumentConfiguration = CtModelConfiguration
      .create()
      .setRouteData(FormTemplateRouteData())
      .setCTDatatableConfiguration(datatableConfiguration)
      .setAutoSetupBreadcrumbs(false)
      .setFilterable(false)
      // NB: [] viene interpretato come "default" (mostra Aggiungi + matita). Usiamo [Read]
      // (sola lettura): array non vuoto ma senza alcun bottone/azione visibile → resta solo il "+".
      .setOperations([CtModelOperator.Read]);

    // Mostra SOLO i documenti non ancora collegati all'utente in dettaglio (filtro gestito dal BE):
    // FormTemplate/List con { Field: "GetOnlyNotConnectedToUser", OperatorType: 54, Value: <oid utente> }.
    this.selectDocumentConfiguration
      .filterValues
      .addConstantFilter(
        CTModelDatatableFilter
          .create()
          .setField('GetOnlyNotConnectedToUser')
          .setValue(userOid)
          .setOperatorType(54 as CtBinaryOperator));

    // Solo i documenti di tipo 6.
    this.selectDocumentConfiguration
      .filterValues
      .addConstantFilter(
        CTModelDatatableFilter
          .create()
          .setField('Type')
          .setValue(6)
          .setOperatorType(CtBinaryOperator.Equal)); // 0 = Equal

    this.addModuleDialogRef = this.dialog.open(this.addModuleDialogTpl, {
      width: '900px',
      maxWidth: '95vw',
      autoFocus: false,
      panelClass: 'add-module-dialog' // per nascondere il bottone "Aggiungi" della toolbar (vedi styles.scss)
    });

  }

  /**
   * Crea l'associazione UserInfo_FormTemplate tra lo user e il documento selezionato
   * (Create standard sul controller, senza passare dal Lookup).
   * I duplicati sono già esclusi dal filtro BE "GetOnlyNotConnectedToLoggedUser".
   */
  private associateModule(userOid: number, template: any): void {

    const templateOid = template?.Oid;
    if (!templateOid) return;

    const body = {
      UserInfo: { Oid: userOid },
      FormTemplate: { Oid: templateOid }
    };

    const configuration = CtModelConfiguration
      .create()
      .setRouteData(UserInfoFormTemplateRouteData());

    this.modelService
      .putInfos(configuration, body)
      ?.subscribe({
        next: () => {
          this.addModuleDialogRef?.close();
          window.location.reload();
        },
        error: (err: any) => console.error('Errore durante il collegamento del documento allo user:', err)
      });

  }

  async checkUser(oid : string) {
    const a = await this.jwtService.getUserInfoOid();
    if (a === oid) return true;
    return false;
  }

}
